<template>
  <div id="app">
    <!-- <Home/> -->
    <router-view/>
  </div>
</template>

<script>
  import Home from '@/view/home.vue'
export default {
  name: 'App',
  components:{Home},
  mounted() {
    console.log(this)
  }
}
</script>

<style>
  body{
    padding: 0;
    margin: 0;
    background-color: #f1f1f1;
  }
  a{
    text-decoration: none;
    color: #d6d6d6;
    font-size: 12px;
  }
  .router-link-active {
    text-decoration: none;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue